import axios from 'axios';
import { captureException } from '@sentry/react';

import pushEvent, {
  pushToDashamail,
  EVENT_MAIL_SUBSCRIPTION,
  EVENT_SUBSCRIBE_SUCCESS,
  EVENT_SUBSCRIBE_ERROR,
} from 'pushEvent';

import {
  SET_EMAIL_FIELD_DATA,
  SUBSCRIBE_FORM_FIELD_EMAIL,
  TOOGLE_AGREEMENT_FIELD_DATA,
  SUBSCRIBE_URL,
  SUBSCRIBE_FORM_STATE_SUCCESS,
} from './constants';
// import { getBodyRequestUrl } from './selectors';

export const changeEmailFieldValue = (value) => ({
  type: SET_EMAIL_FIELD_DATA,
  payload: value,
});

export const sendSubscribe = (value, widgetPosition) => () => {
  const { [SUBSCRIBE_FORM_FIELD_EMAIL]: email } = value;
  const requestUrl = ((window || {}).location || {}).href || '';
  /* dashamail email subscription event */
  pushToDashamail(EVENT_MAIL_SUBSCRIPTION, { email, widgetPosition });
  // ===
  return new Promise((resolve) => {
    axios({
      method: 'POST',
      url: SUBSCRIBE_URL,
      data: {
        json: JSON.stringify({
          subscriber: {
            first_name: '',
            middle_name: '',
            last_name: '',
            phone: '',
            email,
            data_source: `${requestUrl},${widgetPosition}`,
            subscribe: true,
          },
        }),
      },
      responseType: 'json',
      transformRequest: [
        (data) => {
          const serializedData = [];
          Object.keys(data).forEach((k) => {
            if (data[k]) {
              serializedData.push(`${k}=${encodeURIComponent(data[k])}`);
            }
          });
          return serializedData.join('&');
        },
      ],
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then((response) => {
        // console.log('response - ', response);
        if (response.data.IsSucceeded && response.data.Data && response.data.Data.Success) {
          resolve({
            subscribeStatus: SUBSCRIBE_FORM_STATE_SUCCESS,
          });
          pushEvent(EVENT_SUBSCRIBE_SUCCESS);
        } else if (response.data.IsSucceeded && response.data.Data && !response.data.Data.Success) {
          const errorMessage = (response.data.Data.Error || {}).Message;
          resolve({
            errors: {
              [SUBSCRIBE_FORM_FIELD_EMAIL]: errorMessage,
            },
          });
          pushEvent(EVENT_SUBSCRIBE_ERROR);
        } else {
          resolve({
            errors: {
              [SUBSCRIBE_FORM_FIELD_EMAIL]: response.data.ErrorMessage,
            },
          });
          pushEvent(EVENT_SUBSCRIBE_ERROR);
        }
      })
      .catch((error) => {
        captureException(error);
        resolve({
          errors: {
            [SUBSCRIBE_FORM_FIELD_EMAIL]: error.message,
          },
        });
        pushEvent(EVENT_SUBSCRIBE_ERROR);
      });
  });
};

export const toogleAgreementField = (value) => (dispatch) =>
  dispatch({
    type: TOOGLE_AGREEMENT_FIELD_DATA,
    payload: value,
  });
